import Bowser from 'bowser';
import { ToasterTexts } from '../components/shared/constants';
import { ToasterType } from '../components/shared/toaster/toaster.model';
import Config from '../config';
import { AxiosInstance } from '../helpers/AxiosInstance';
import setToast from '../helpers/toaster.helper';
import { UtilityService } from './UtilityService';

const downLoadFile = (referenceId: any) => {
  return AxiosInstance.get(`${Config.API_URL}/api/File/${referenceId}/download`, { responseType: 'arraybuffer' });
};

const downLoadFileByURL = (url: string) => {
  return AxiosInstance.get(url, { responseType: 'arraybuffer' });
};

const viewFile = (referenceId: any) => {
  return AxiosInstance.get(`${Config.API_URL}/api/File/${referenceId}/view`, { responseType: 'arraybuffer' });
};

const UploadFile = (referenceId: any) => {
  return AxiosInstance.get(`${Config.API_URL}/api/File/${referenceId}_en/upload`, { responseType: 'arraybuffer' });
};

const UploadNewFile = (file: any, fileName: string, fileType: any) => {
  const config = fileName && fileType ? {
    headers: {
      "file-name": fileName,
      "file-type": fileType
    }
  } : undefined;
  console.log("files", file, fileName, fileType)
  return AxiosInstance.post(`${Config.API_URL}/api/File/upload`, file, config);
};

async function fetchImageAsBase64(url: string): Promise<string> {
  const response = url.startsWith(`${Config.API_URL}/api/File/`)
    ? await AxiosInstance.get(url, { responseType: "blob" }) : { data: await (await fetch(url)).blob() };

  const blob = response.data as Blob;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string); // this will be base64
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob); // converts blob to base64
  });
}

const fileDownload = async (media) => {
  setToast(ToasterTexts.FILE_DOWNLOAD_STARTED, ToasterType.INFO)
  const isMobile = window.outerWidth <= 835;
  let isSafari = false;
  const browser = Bowser.getParser(window.navigator.userAgent);
  const result = browser.getBrowser();
  if (result.name === "Safari") {
    isSafari = true;
  }

  if (!!media) {
    if (media.ID) {
      if (isMobile && UtilityService.isIPhone(navigator.userAgent)) {
        try {
          const response = await FileService.viewFile(media.ID);
          
          const file = new File([response.data], media.Name || "download", { type: media.ContentType || "application/octet-stream" });
          if (typeof navigator.canShare === "function" && navigator.canShare({ files: [file] })) {
            await navigator.share({ files: [file] });
          } else {
            const url = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", media.Name);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          setToast(ToasterTexts.FILE_DOWNLOAD_SUCCESS, ToasterType.SUCCESS);
        } catch (err: any) {
          console.log("err", err);
        }

      } else {
        FileService.viewFile(media.ID).then((response) => {
          const url = URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", media.Name);
          link.click();
          setToast(ToasterTexts.FILE_DOWNLOAD_SUCCESS, ToasterType.SUCCESS)
        });
      }
    }
    else {
      if (isMobile && isSafari && media.ContentType === "application/pdf") {
        const base64Data = media.Url.split(",")[1]; // remove data:application/pdf;base64,
        const blob = base64ToBlob(base64Data, "application/pdf");
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", media.Name);
        link.click();
        setToast(ToasterTexts.FILE_DOWNLOAD_SUCCESS, ToasterType.SUCCESS);
      } else {
        const link = document.createElement("a");
        link.href = media.Url;
        link.setAttribute("download", media.Name);
        link.click();
        setToast(ToasterTexts.FILE_DOWNLOAD_SUCCESS, ToasterType.SUCCESS);
      }
    }
  }
}


function base64ToBlob(base64: string, type: string) {
  const byteCharacters = atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type });
}

const downloadWasabiFiles = (url: string, name: string) => {
  FileService.downLoadFileByURL(url).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name);
    link.click();
  }).catch(err => console.log("err", err))
}

const getBlobFromUrl = async (url: string): Promise<Blob> => {
  if (!url) return new Blob();

  if (url.startsWith("blob:") || url.startsWith("data:")) {
    return (await fetch(url)).blob();
  }

  if (url.startsWith(`${Config.API_URL}/api/File/`)) {
    const response = await AxiosInstance.get(url, { responseType: "blob" });
    return response.data;
  }

  return (await fetch(url)).blob();
};


export const FileService = {
  downLoadFile,
  viewFile,
  UploadFile,
  downLoadFileByURL,
  UploadNewFile,
  fileDownload,
  downloadWasabiFiles,
  getBlobFromUrl,
};
